<template>
    <div ref="trustSymbolContainer" class="trust-symbol-container"></div>
</template>

<script>
export default {
    mounted() {
        const trustPaymentContainer = document.querySelector('.configurator-trust-payment-icons');

        if (trustPaymentContainer) {
            this.$refs.trustSymbolContainer.innerHTML = trustPaymentContainer.innerHTML;
        }
    }
};
</script>
